export const cols = [{
	prop: 'entname',
	label: '供货商名称',
	width: '180',
	align: 'center'
}, {
	prop: 'shopName',
	label: '供货商店铺名称',
	width: '200',
	align: 'center'
}, {
	prop: 'orderCount',
	label: '订单总数',
	width: '200',
	align: 'center'
}, {
	prop: 'refundOrderCount',
	label: '退单总数',
	width: '200',
	align: 'center'
}, {
	prop: 'countOrder',
	label: '单据总数',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumTotalPrice',
	label: '订单总额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumFinalPrice',
	label: '退单总额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumOrderPrice',
	label: '单据总额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumFreight',
	label: '运费',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumproductPrice',
	label: '商品总额',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumPlatformPrice',
	label: '平台佣金',
	width: '140',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'commissionFee',
	label: '支付服务费',
	width: '120',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumTotalFactPrice',
	label: '实收总额',
	width: '200',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumOffLinePrice',
	label: '线下支付总额',
	width: '180',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumOffLinePer',
	label: '线下支付占比',
	width: '140',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumDragonPrice',
	label: '商龙钱包支付总额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumDragonPer',
	label: '商龙钱包支付占比',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumAlipayPrice',
	label: '支付宝支付总额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumAlipayPer',
	label: '支付宝支付占比',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'weChatPrice',
	label: '微信支付总额',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'weChatPer',
	label: '微信支付占比',
	width: '160',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumPaymentPrice',
	label: '预付货款支付总额',
	width: '200',
	headerAlign: 'center',
	align: 'right'
}, {
	prop: 'sumPaymentPer',
	label: '预付货款支付占比',
	width: '200',
	headerAlign: 'center',
	align: 'right'
}]
